export const blockIconsUiactionsMoreVertNew = (
	<span className='material-symbols-outlined'>more_vert</span>
);
